import { useRef, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  IconButton,
  Snackbar,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';


function QrFeedbackPage() {
  // const firstNameRef = useRef();
  // const lastNameRef = useRef();
  const messageRef = useRef();
  // const emailRef = useRef();
  // const countryRef = useRef();

  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [missingFields, setMissingFields] = useState(false);
  const [trySubmit, setTrySubmit] = useState(false);
  const [fileList, setFileList] = useState([]);

  const darkMode = useTheme().palette.mode === 'dark';

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);

    setFileList(prevFiles => {
      const merged = [...prevFiles, ...newFiles];
      const unique = merged.filter(
        (file, index, self) =>
          index === self.findIndex(
            f => f.name === file.name && f.size === file.size
          )
      );

      return unique;
    });
  };

  const handleSubmit = async(e) => {
    setTrySubmit(true);
    e.preventDefault();

    const user = JSON.parse(sessionStorage.getItem('mts_user'));


    const formData = new FormData();
    // formData.append('firstName', firstNameRef.current.value);
    // formData.append('lastName', lastNameRef.current.value);
    formData.append('fullName', user.fullName);
    formData.append('country', user.country);
    formData.append('email', user.email);
    formData.append('message', messageRef.current.value);

    for (let file of fileList) {
      formData.append('files', file, file.name)
    }
    console.log(formData.get('files'))

    // if (!formData.get('firstName') || !formData.get('lastName') || !formData.get('message')) { setMissingFields(true); setErrorAlert(true); return; }
    if (!formData.get('message')) { setMissingFields(true); setErrorAlert(true); return; }

    try {
      const response = await fetch('/api/send-feedback', {
        method: 'POST',
        body: formData
      });
      // setSuccessAlert(true);
      if (response.status === 200) {
        setSuccessAlert(true);
      } else{
        throw new Error(`response: {response.status}, an unexpected error occured.`)
      }
      // firstNameRef.current.value = '';
      // lastNameRef.current.value = '';
      messageRef.current.value = '';
      setTrySubmit(false);
    } catch (err) {
      setErrorAlert(true);
      console.error(err);
    }

  }

  return (
    <Box>
      <Typography variant='h4' fontWeight={700} sx={{ mb: isMobile ? 2 : 4 }}>
        Feedback
      </Typography>

      <Grid container sx={{ p: { xs: 2, sm: 4 }, backgroundColor: 'background.paper', borderRadius: '10px', boxShadow: !isMobile ? darkMode ? '0 0 10px 5px rgba(255, 255, 255, 0.15)' : '0 0 10px 5px rgba(0,0,0,0.15)' : '', }}>
        <Grid item xs={12} sm={6.5}>
          <Typography variant='h6'>Contribute to Better Solutions</Typography>
          <Typography variant='body1' color='text.secondary' sx={{ mb: 2, maxWidth: { sm: '80%' }, lineHeight: 1.25 }}>This page is your direct line to share feedback with our technical team.</Typography>
          <Typography variant='body1' color='text.secondary' sx={{ mb: 0.75, maxWidth: {sm: '80%' }, lineHeight: 1.25 }}>Use it to report issues, suggest improvements, or share ideas based on your experiences.</Typography>
          <Typography variant='body1' color='text.secondary' sx={{ mb: 0.75, maxWidth: { sm: '80%' }, lineHeight: 1.25 }}>You can also attach photos, videos, or documents to help explain your feedback.</Typography>
          <Typography variant='body1' color='text.secondary' sx={{ mb: 2, maxWidth: { sm: '80%' }, lineHeight: 1.25 }}>Submissions are reviewed by our team and used to improve our systems, equipment, and processes across Menard.</Typography>
          <Typography variant='body1' color='text.secondary' sx={{ lineHeight: 1.25 }}>All input is welcome, from employees and partners alike.</Typography>
        </Grid>
        <Grid item xs={12} sm={5.5} sx={{ mt: { xs: 2, sm: 0 } }}>
          <Stack direction='column'>
            <TextField
              id='message'
              inputRef={messageRef}
              label='Message'
              variant='outlined'
              autoComplete='off'
              error={trySubmit ? messageRef.current.value === '': false}
              required
              multiline
              minRows={2}
              maxRows={8}
              InputLabelProps={{ shrink: isMobile ? true : undefined }}
              sx={{
                mt: 2,
                '& textarea': {
                  sm: {
                    color: 'text.secondary',
                    resize: 'vertical',
                    overflow: 'auto',
                    '&::-webkit-scrollbar': { background: 'transparent', width: 15 },
                    '&::-webkit-scrollbar-thumb': { backgroundColor: 'currentColor', borderRadius: 8, border: '3px solid transparent', backgroundClip: 'padding-box' },
                    '&::-webkit-scrollbar-corner': { backgroundColor: 'transparent' },
                    '&::-webkit-resizer': {
                      background: 'linear-gradient(135deg, transparent 0 14px, currentColor 15px 16px, transparent 16px 17px, currentColor 18px 19px, transparent 19px)'
                    }
                  }
                },
              }}
            />
            <Stack direction='row' justifyContent='space-between' alignItems='top' sx={{ mt: 2 }}>
              <Stack direction='row' spacing={{ xs: 1, sm: 2 }}>
                <Stack>
                  <Button variant='contained' component='label' sx={{ size: { xs: 'small', sm: 'medium' } }}>
                    <AttachFileIcon /> {isMobile ? '' : 'Attach Files'}
                    <input type='file' multiple hidden onChange={handleFileChange} />
                  </Button>
                </Stack>
                {fileList.length > 0 && (
                  <Typography variant='body2' alignSelf='center' sx={{ color: 'text.secondary' }}>
                    {fileList.length} selected file(s)
                  </Typography>
                )}
              </Stack>
              <Stack>
                <Button variant='contained' onClick={handleSubmit} sx={{ size: { xs: 'small', sm: 'medium' } }}>Submit</Button>
              </Stack>
            </Stack>
            <Snackbar 
            open={successAlert}
            autoHideDuration={3000}
            onClose={() => setSuccessAlert(false)}
            message="Feedback submitted successfully"
            />
            <Snackbar
              open={errorAlert}
              autoHideDuration={3000}
              onClose={() => setErrorAlert(false)}
              message={missingFields ? "Please fill out all required fields": "An error occured while submitting your feedback."}
            />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  )
}

export default QrFeedbackPage;
